export default {
    name: "NewsLetter",

    props: [],

    data() {
        return {
            disabled: false,
            loading: false,
            showMessage: false,
            success: false,
            email: ""
        };
    },

    components: {},

    computed: {
        caption() {
            if (this.loading) {
                return "Signing up...";
            }
            return "Sign up";
        }
    },

    methods: {
        submit() {
            let form = $(this.$refs.form);
            let self = this;
            self.toggleDisable();

            $.ajax({
                type: "POST",
                url: `${form.attr("action")}`,
                data: form.serialize(),
                success: function(response) {
                    self.toggleDisable();
                    self.showMessage = true;
                    self.success = true;
                    self.email = "";
                },
                error: function(response) {
                    self.toggleDisable();
                    self.showMessage = true;
                    self.success = false;
                }
            });
        },

        toggleDisable() {
            this.disabled = !this.disabled;
            this.loading = !this.loading;
        }
    },

    created() {},

    mounted() {
        console.info(`loading ${this.$options.name}`);
    }
};



// WEBPACK FOOTER //
// ./js/components/NewsLetter.js